document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-route-tabs]').forEach((container) => {
    const tabs = Array.from(container.querySelectorAll('[data-route-tab]'));
    const panels = Array.from(container.querySelectorAll('[data-route-panel]'));

    function activateTab(tab) {
      const id = tab.dataset.routeTab;

      tabs.forEach((t) => {
        const active = t === tab;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', String(active));
        t.setAttribute('tabindex', active ? '0' : '-1');
      });

      panels.forEach((p) => {
        const show = p.dataset.routePanel === id;
        p.classList.toggle('is-active', show);
        p.hidden = !show;
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activateTab(tab));
    });

    tabs.forEach((tab) => {
      tab.addEventListener('keydown', (e) => {
        const idx = tabs.indexOf(tab);
        let next = -1;
        if (e.key === 'ArrowRight') next = (idx + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') next = (idx - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next >= 0) {
          e.preventDefault();
          activateTab(tabs[next]);
          tabs[next].focus();
        }
      });
    });
  });

  document.querySelectorAll('[data-route-guide]').forEach((guide) => {
    const panel = guide.closest('[data-route-panel]') || guide.closest('.delivery-hub__routes');
    const map = panel && panel.querySelector('[data-route-map]');
    const mapPin = map && map.querySelector('[data-route-pin]');
    const pinLabel = mapPin && mapPin.querySelector('[data-route-pin-label]');
    const status = panel && panel.querySelector('[data-route-status]');
    const stops = Array.from(guide.querySelectorAll('[data-route-stop]'));

    if (!map || !mapPin || !pinLabel || !stops.length) return;

    stops.forEach((stop) => {
      stop.addEventListener('click', () => {
        const name = stop.querySelector('strong').textContent.trim();

        stops.forEach((item) => {
          const active = item === stop;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });

        map.style.setProperty('--map-x', `${stop.dataset.mapX}%`);
        map.style.setProperty('--map-y', `${stop.dataset.mapY}%`);
        pinLabel.textContent = name;
        if (status) status.textContent = `${name} highlighted on the map.`;

        mapPin.classList.remove('is-dropping');
        window.requestAnimationFrame(() => mapPin.classList.add('is-dropping'));
      });
    });
  });
});
